import { Add, Delete, Edit } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { RemoveRedEye } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, { useEffect, useState } from "react";
import { QueryClient, useMutation } from "react-query";
import Search from "components/Search/Search";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import DeleteModal from "components/UI/Form/partials/Delete";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import AddModalReseller from "./partials/Add";
import EditModalReseller from "./partials/Edit";
import { addFaq, deleteFaq, editFaq, FaqsCells, getFaqs } from "framework/faqs";
import { IFaqs, IFaqsInput } from "models/faqs";

function isEditorContentEmpty(html?: string): boolean {
  if (!html) return true;

  const div = document.createElement('div');
  div.innerHTML = html;

  // Replace &nbsp;, zero-width space, and trim all whitespace
  const text = div.textContent!
    .replace(/\u00A0/g, '')  // &nbsp;
    .replace(/\u200B/g, '')  // zero-width space
    .trim();

  return text === '';
}

interface Props {
  feature: Feature;
}


const Faqs2: React.FC<Props> = ({ feature }) => {

  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterPolicies, setFilterPolicies] = useState<IFaqs[]>([] as IFaqs[]);
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [SelectedPolicy, setSelectedPolicy] = useState<IFaqs | null>(null);
  const [inputObj, setInputObj] = useState<IFaqsInput>({} as IFaqsInput);
  const { setAlert } = useAlert();

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addUserMutation = useMutation({
    mutationFn: (createInput: IFaqsInput) => {
      return addFaq(createInput);
    },
  });

  const editUserMutation = useMutation({
    mutationFn: (data: { createInput: IFaqsInput; resellerId: string }) => {
      return editFaq(data.createInput, data.resellerId);
    },
  });

  const deleteUserMutation = useMutation({
    mutationFn: (id: string) => {
      return deleteFaq(id);
    },
  });

  const {
    loading,
    data: Policies,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getFaqs(),
    fetchPermission: async () => null,
    section: "Faqs2",
    onSuccess: (data) => setFilterPolicies(data),
  });


  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenAdd = () => {
    setOpenAdd(true);
    setInputObj((prev) => ({
      ...prev,
      CountryCode: '+971',
      dateOfBirth: new Date().toISOString()
    }));
  }

  const handleOpenEdit = (user: IFaqs) => {
    setSelectedPolicy(user);
    setOpenEdit(true);
  };

  const handleOpenDelete = (user: IFaqs) => {
    setSelectedPolicy(user);
    setOpenDelete(true);
  };

  const handleClose = () => {
    setOpenAdd(false)
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedPolicy(null);
    setInputObj({} as IFaqsInput)
  }

  const getBodyCells = (row: IFaqs) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "question")
        return {
          id: "question",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.question}</Typography>
            </TableCell>
          ),
        };
      if (key === "answer")
        return {
          id: "answer",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2"><div dangerouslySetInnerHTML={{ __html: row.answer }} /></Typography>
            </TableCell>
          ),
        };


      if (key === "id")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
              >

                <Tooltip title={"Edit"}>
                  <IconButton
                    size={"small"}
                    color={"primary"}
                    onClick={() => handleOpenEdit(row)}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>


                <Tooltip title={"Delete"}>
                  <IconButton
                    size={"small"}
                    sx={{
                      color: "red",
                    }}
                    onClick={() => handleOpenDelete(row)}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>


                {/* <Tooltip title={`Go to ${userId === '1' ? "User" : "Doctor"}`}>
                  <IconButton
                    size={"small"}
                    sx={{
                      color: "#9e9e52",
                    }}
                    onClick={() => navigate(`${row.userId}`)}
                  >
                    <RemoveRedEye />
                  </IconButton>
                </Tooltip> */}

              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };

  const handleAdd = async () => {


    // if (
    //   !isValidNumber(inputObj.countryCode + inputObj.contactNumber))


    //   return setAlert({
    //     open: true,
    //     message: "This Phone is not valid in this country",
    //     type: "error",
    //   });

    try {
      setLoading2(true);

      await addUserMutation.mutateAsync(inputObj);
      setAlert({
        open: true,
        message: `Faq added successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IFaqsInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEdit = async () => {

    if ((inputObj.answer && isEditorContentEmpty(inputObj.answer)) || inputObj.question === null)
      return setAlert({
        open: true,
        message: "Fill all required fields",
        type: "error",
      });


    let createInput: IFaqsInput = {
      ...inputObj?.question && { question: inputObj?.question },
      ...inputObj.answer && !isEditorContentEmpty(inputObj?.answer) && { answer: inputObj.answer },
    };
    try {
      setLoading2(true);
      await editUserMutation.mutateAsync({
        createInput,
        resellerId: SelectedPolicy!?.id?.toString()
      });



      setAlert({
        open: true,
        message: `Faq updated successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IFaqsInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteUserMutation.mutateAsync(SelectedPolicy!.id?.toString());
      setAlert({
        open: true,
        message: `Faq deleted successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleSearch = (value: string) => {
    if (!Policies) return;

    const searchTerm = value.trim().toLowerCase();

    if (!searchTerm) {
      setFilterPolicies(Policies);
      return;
    }

    const filtered = Policies.filter(({ answer, question }) => {
      const fullText = `${answer} ${question}`.toLowerCase();
      return fullText.includes(searchTerm);
    });

    setFilterPolicies(filtered);
  };


  let addBasicFields: IFormField[] = [
    {
      name: 'question',
      label: 'Question',
      type: InputTypes.TEXT,
      placeholder: 'Enter Question',
      internalLabel: true,
      required: true
    },
    {
      name: 'answer',
      label: 'Answer',
      type: InputTypes.EDITOR,
      placeholder: 'Enter Answer',
      internalLabel: true,
      required: true
    }
  ];


  let editBasicFields: IFormField[] = [
    {
      name: 'question',
      label: 'Question',
      type: InputTypes.TEXT,
      placeholder: 'Enter Question',
      defaultValue: SelectedPolicy?.question || '',
      internalLabel: true,
      required: true
    },
    {
      name: 'answer',
      label: 'Answer',
      type: InputTypes.EDITOR,
      placeholder: 'Enter Answer',
      defaultValue: SelectedPolicy?.answer || '',
      internalLabel: true,
      required: true
    }
  ];


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"

        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
            sx={{ mb: 4 }}
          >
            <Typography
              variant="h3"
              color={"header.primary"}
            >
              {(feature.name)}
            </Typography>

            <Tooltip title={"Add"}>
              <IconButton
                sx={{
                  color: "black",
                  height: 40,
                  width: 40,
                  transition: "0.5s",
                }}
                onClick={handleOpenAdd}
              >
                <Add />
              </IconButton>
            </Tooltip>

          </Stack>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              direction={{ lg: "row", xs: "column" }}
              spacing={1}
              width={"100%"}
            >
              <Search handleChange={handleSearch} placeholder={"Search"} />
            </Stack>
          </Stack>
        </Grid>

        {FilterPolicies.length > 0 && (
          <List
            headCells={FaqsCells}
            data={FilterPolicies}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}
        {(!FilterPolicies || FilterPolicies.length === 0) &&

          <EmptyContent
            icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
            header={"No Policies"}
            message={`No Policy Exists Yet`}
          />
        }


      </Stack>

      {openAdd && (
        <AddModalReseller
          open={openAdd}
          loading={loading2}
          disabled={isEditorContentEmpty(inputObj?.answer) || !inputObj.question}
          title={`Add Faq`}
          basicFields={addBasicFields}
          onClose={handleClose}
          onSubmit={handleAdd}
          onChanges={handleChange}
        />
      )}
      {openEdit && (
        <EditModalReseller
          open={openEdit}
          loading={loading2}
          title={`Edit Faq`}
          basicFields={editBasicFields}
          onClose={handleClose}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteModal
          open={openDelete}
          loading={loading2}
          title={`Delete Faq`}
          description={`Are You Sure You Want to delete this Faq`}
          onClose={handleClose}
          onSubmit={handleDelete}
        />
      )}
      {/* {openView && (
        <ViewClientsModal
          open={openView}
          title="View Client Subscriptions"
          feature={feature}
          onClose={handleClose}
        />
      )} */}
    </>
  );
};

export default Faqs2;
